<template>
	<div class="games-fps">
		<div class="games-fps__games">
			<game-fps-item
				v-for="game in selectedGames"
				:key="`fps-game-${game.id}`"
				:game="game"
				:fps="+game.game_value"
				image-key="image"
			/>
		</div>
		<p class="games-fps__disclaimer">
			FPS speeds are measured at {{ resolutionText }} resolution using each game’s highest graphic setting
		</p>
		<p v-if="showFpsPendingMobile" class="games-fps__disclaimer games-fps__pending">
			FPS pending: {{ fpsPendingMessage }}
		</p>
	</div>
</template>

<script>
import GameFpsItem from "@c/store/build/game-fps-item";
import CONSTANTS from "@/config/constants";

export default {
	name: "GamesFps",
	components: {
		GameFpsItem
	},
	props: {
		resolutionText: {
			type: String,
			required: true
		},
		selectedGames: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			fpsPendingMessage: CONSTANTS.FPS_PENDING_MESSAGE
		};
	},
	computed: {
		showFpsPendingMobile() {
			return this.selectedGames.some(game => Number(game.game_value) == 0);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.games-fps {
	width: 280px;
	margin: 0 auto;
	color: $white;
	text-align: center;

	@media (min-width: 991px) and (max-width: 1200px) {
		width: auto;
	}

	@media (max-width: 500px) {
		width: auto;
	}

	&__games {
		display: flex;
		justify-content: center;
		margin-bottom: 10px;
	}

	&__disclaimer {
		text-align: center;
		margin-bottom: 20px;
		color: $white;
		font-family: Akkurat-Light;
		font-size: 14px;
		font-weight: 300;
		line-height: 17px;
	}

	&__pending {
		display: none;

		@media (hover: none) {
			display: block;
		}
	}
}
</style>
